export default __webpack_public_path__ + "static/Roboto-Regular-fc2b5060f7accec5cf74437196c1b027.ttf";